// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== FULLCALENDAR STYLES ===== */

/* ===== BASE STYLES ===== */
.fc {
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI',
               Helvetica, Arial, 'Apple Color Emoji', 'Segoe UI Emoji',
               'Segoe UI Symbol' !important;
  display: block;
  overflow-x: visible;
  position: relative;
  margin-top: 0;
}

/* ===== DARK MODE (Tailwind adds .dark on <html>) ===== */
.dark .fc {
  color: #fafafaff;
}

.dark .fc .fc-scrollgrid,
.dark .fc .fc-timegrid-body,
.dark .fc .fc-datagrid-body {
  background: #0d1117;
}

.dark .fc .fc-col-header,
.dark .fc .fc-col-header-cell {
  background-color: #081B33 !important; /* match sidebar dark */
  border-color: #081B33 !important;
  color: #fafafaff !important;
}

.dark .fc .fc-col-header-cell {
  border-bottom: 1px solid #081B33 !important;
  border-right: 1px solid #081B33 !important;
}

.dark .fc-theme-standard .fc-scrollgrid {
  border-color: #081B33 !important; /* remove white border in dark mode */
}

.dark .fc .fc-scrollgrid-section-header {
  background: #1A1C23;
}

.dark .fc .fc-timegrid-axis,
.dark .fc .fc-timegrid-slot-label {
  background-color: #1A1C23 !important;
  color: #A0AEC0 !important;
  border-right: 2px solid #2E3138 !important;
}

.dark .fc .fc-timegrid-slot,
.dark .fc .fc-timegrid-slot-lane {
  border-right: 0px solid #2E3138 !important;
  border-bottom: 0px solid #2E3138 !important;
}

.dark .fc .fc-timegrid-slot.fc-day-hover,
.dark .fc .fc-timegrid-slot:hover {
  background-color: rgba(49, 196, 171, 0.08) !important;
}

.dark .fc-day-today {
  background-color: rgba(49, 196, 171, 0.1) !important;
}

/* Hide FullCalendar's internal loading indicator; we render our own overlay loader */
.fc .fc-loading {
  display: none !important;
}

/* ===== LAYOUT & POSITIONING ===== */

/* Main calendar wrapper with offset for sticky header */
.fc-has-offset {
  padding-top: var(--header-offset, 64px);
  min-height: calc(100vh - var(--header-offset, 64px));
}

/* Calendar grid background */
.fc .fc-scrollgrid {
  background: #ffffff;
  top: var(--header-offset, 0px) !important;
}

/* View harness */
.fc-view-harness {
  margin-top: 0 !important;
}

.fc-resourceTimeGridDay-view .fc-view-harness {
  min-width: fit-content;
}

.fc-resourceTimeGridDay-view .fc-scrollgrid {
  min-width: 100%;
}

/* ===== SCROLLING ===== */
.fc-scroller {
  overflow-x: auto !important;
  overflow-y: auto !important;
}

/* ===== HEADER STYLES ===== */

/* Day-of-week header row (Mon, Tue, etc.) - Sticky positioning */
.fc .fc-col-header {
  position: sticky;
  top: var(--header-offset, 64px) !important;
  z-index: 35;
  background-color: #223688 !important;
}

/* Individual header cells */
.fc .fc-col-header-cell {
  padding: 8px 4px !important;
  background-color: #223688 !important;
  color: #ffffff !important;
  font-weight: bold;
  border-bottom: 1px solid #ffffff !important;
  border-right: 1px solid #ffffff !important;
  font-size: 0.9rem;
  position: sticky;
  top: var(--header-offset, 64px);
  z-index: 9999;
}

/* Section header */
.fc-scrollgrid-section-header {
  position: sticky;
  top: var(--header-offset, 64px);
  z-index: 5;
  background: white;
}

/* ===== TIME GRID STYLES ===== */

/* Time axis (left column with times) */
.fc-timegrid-axis {
  background-color: #ffffff !important;
  color: #4e7bc3 !important;
  font-weight: 500;
  font-size: 0.875rem;
  border-right: 2px solid #e5e7eb !important;
  position: relative;
  top: max(--header-offset, 96px) !important;
}

/* Time slot rows */
.fc-timegrid-slot {
  border-right: 0px solid #59606e !important;
  border-bottom: 0px solid #c9cdd7 !important;
  height: 20px !important;
}

/* Time slot lanes (cells) */
.fc .fc-timegrid-slot-lane {
  border-right: 0px solid #334976 !important;
  border-bottom: 0px solid #e5e7eb !important;
  min-height: 30px;
}

/* Remove border from last row */
.fc .fc-timegrid-body tr:last-child .fc-timegrid-slot-lane {
  border-bottom: none !important;
}

/* Time labels */
.fc-timegrid-slot-label {
  background-color: #ffffff !important;
  color: #4e7bc3 !important;
  font-weight: 500;
  font-size: 0.875rem;
  border-right: 2px solid #e5e7eb !important;
}

/* Time grid body */
.fc-timegrid-body {
  margin-top: 0;
}

/* Time grid event short */
.fc-timegrid-event-short .event-content-wrapper {
  padding: 0 !important;
}

.fc-resourceTimeGridDay-view .fc-datagrid-body {
  margin-top: 0;
}

/* ===== HOVER STATES ===== */
.fc .fc-timegrid-slot.fc-day-hover {
  background-color: #6b7080 !important;
}

.fc .fc-timegrid-slot:hover {
  background-color: inherit !important;
}

/* ===== TODAY HIGHLIGHT ===== */
.fc-day-today {
  background-color: #f0f0f240 !important;
}

/* ===== STANDARD EVENT STYLES & FULL-WIDTH OVERRIDES ===== */

/* 1. Reset the master foreground layer to be fully edge-to-edge */
.fc .fc-timegrid-col-events {
  left: 0px !important;
  right: 0px !important;
  width: 100% !important; 
  margin: 0px !important;
}

/* 2. Reset the individual event harnesses inside so they stretch flush */
.fc .fc-timegrid-col-events .fc-timegrid-event-harness {
  margin-right: 0px !important; 
  margin-left: 0px !important;
}

/* 3. Base standard event styling */
.fc-event {
  background-color: #223688 !important;
  color: white !important;
  border-radius: 0px !important; /* Square corners */
  padding: 0 !important;
  font-weight: 600;
  font-size: 0.875rem;
  transition: filter 0.2s ease;
  z-index: 100 !important; 
  
  /* CRITICAL FIX: box-sizing prevents borders from expanding the event past its allotted width */
  box-sizing: border-box !important;
  border: 1px solid #1a2a6c !important; 
  box-shadow: none !important;
}

/* ===== EXCEPTION / BACKGROUND EVENT STYLES ===== */

.fc .fc-timegrid-col-bg .fc-non-business {
  z-index: 0;
}

/* 1. Force the FullCalendar harness to span the full width of the col-frame */
.fc .fc-timegrid-col-bg .fc-timegrid-bg-harness {
  left: 0px !important;
  right: 0px !important;
  width: 100% !important;
  margin: 0px !important;
}

/* 2. Force the background event itself to perfectly fill the harness */
.fc .fc-timegrid-col-bg .fc-bg-event,
.fc .fc-bg-event,
.fc-event.fc-bg-event {
  left: 0px !important;
  right: 0px !important;
  width: 100% !important;
  margin: 0px !important;
  border-radius: 0px !important;
  border: none !important;
  outline: none !important;
  z-index: 1 !important;
  background-color: #fee2e2 !important; /* Light red background */
  opacity: 0.85 !important;
}

/* 3. Ensure the column background area doesn't squeeze the harness */
.fc .fc-timegrid-col-bg {
  padding: 0px !important;
  margin: 0px !important;
}

/* 4. Exception interactions */
.fc .exception-event {
  pointer-events: auto;
}


.fc-timegrid-col.fc-day-disabled {
  pointer-events: none;
}


/* ===== CURRENT TIME INDICATOR ===== */
.fc .fc-timegrid-now-indicator-arrow {
  border-color: transparent transparent #9ca3de transparent !important;
}

.fc .fc-timegrid-now-indicator-line {
  border-top: 2px solid #223688 !important;
  z-index: 50;
}


/* ===== SPECIFIC APPOINTMENT STATUS COLORS ===== */

/* In-Transit appointments - Gray */
.fc-event.appt-in-transit,
.appt-in-transit.fc-timegrid-event {
  background-color: #d6d8dd !important;
  border-color: #6b7280 !important; 
  color: #1f2937 !important; 
}

.fc-event.appt-in-transit .fc-event-main,
.fc-event.appt-in-transit .fc-event-title,
.fc-event.appt-in-transit .fc-event-time,
.appt-in-transit .fc-event-main,
.appt-in-transit .fc-event-title,
.appt-in-transit .fc-event-time {
  color: #1f2937 !important; 
}

/* Live Load appointments - Emerald Green */
.fc-event.appt-live-load,
.appt-live-load.fc-timegrid-event {
  background-color: #a7f3d0 !important;
  border-color: #059669 !important;
  color: #022c22 !important;
}
.fc-event.appt-live-load .fc-event-main,
.fc-event.appt-live-load .fc-event-title,
.fc-event.appt-live-load .fc-event-time,
.appt-live-load .fc-event-main,
.appt-live-load .fc-event-title,
.appt-live-load .fc-event-time {
  color: #022c22 !important;
}

/* Drop Trailer appointments - Orange Yellow */
.fc-event.appt-drop-trailer,
.appt-drop-trailer.fc-timegrid-event {
  background-color: #fed7aa !important;
  border-color: #ea580c !important;
  color: #431407 !important;
}
.fc-event.appt-drop-trailer .fc-event-main,
.fc-event.appt-drop-trailer .fc-event-title,
.fc-event.appt-drop-trailer .fc-event-time,
.appt-drop-trailer .fc-event-main,
.appt-drop-trailer .fc-event-title,
.appt-drop-trailer .fc-event-time {
  color: #431407 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/appt-calendar.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC,4BAA4B;AAC5B;EACE;;2CAEyC;EACzC,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA,0DAA0D;AAC1D;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;EAEE,oCAAoC,EAAE,uBAAuB;EAC7D,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC,EAAE,qCAAqC;AACzE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;;EAEE,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;;EAEE,qDAAqD;AACvD;;AAEA;EACE,oDAAoD;AACtD;;AAEA,qFAAqF;AACrF;EACE,wBAAwB;AAC1B;;AAEA,qCAAqC;;AAErC,wDAAwD;AACxD;EACE,uCAAuC;EACvC,oDAAoD;AACtD;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,8BAA8B;;AAE9B,iEAAiE;AACjE;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,WAAW;EACX,oCAAoC;AACtC;;AAEA,4BAA4B;AAC5B;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;EACjB,2CAA2C;EAC3C,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,UAAU;EACV,iBAAiB;AACnB;;AAEA,iCAAiC;;AAEjC,uCAAuC;AACvC;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,gCAAgC;AAChC;EACE,sCAAsC;AACxC;;AAEA,6DAA6D;;AAE7D,kEAAkE;AAClE;EACE,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,yEAAyE;AACzE;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,mCAAmC;AACnC;EACE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B,EAAE,mBAAmB;EAClD,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;;EAEvB,+FAA+F;EAC/F,iCAAiC;EACjC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,oDAAoD;;AAEpD;EACE,UAAU;AACZ;;AAEA,8EAA8E;AAC9E;EACE,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,uEAAuE;AACvE;;;EAGE,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,oCAAoC,EAAE,yBAAyB;EAC/D,wBAAwB;AAC1B;;AAEA,qEAAqE;AACrE;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;AACtB;;;AAGA;EACE,oBAAoB;AACtB;;;AAGA,uCAAuC;AACvC;EACE,oEAAoE;AACtE;;AAEA;EACE,wCAAwC;EACxC,WAAW;AACb;;;AAGA,mDAAmD;;AAEnD,mCAAmC;AACnC;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;;;;;;EAME,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;;;;;;EAME,yBAAyB;AAC3B","sourcesContent":["/* ===== FULLCALENDAR STYLES ===== */\n\n/* ===== BASE STYLES ===== */\n.fc {\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI',\n               Helvetica, Arial, 'Apple Color Emoji', 'Segoe UI Emoji',\n               'Segoe UI Symbol' !important;\n  display: block;\n  overflow-x: visible;\n  position: relative;\n  margin-top: 0;\n}\n\n/* ===== DARK MODE (Tailwind adds .dark on <html>) ===== */\n.dark .fc {\n  color: #fafafaff;\n}\n\n.dark .fc .fc-scrollgrid,\n.dark .fc .fc-timegrid-body,\n.dark .fc .fc-datagrid-body {\n  background: #0d1117;\n}\n\n.dark .fc .fc-col-header,\n.dark .fc .fc-col-header-cell {\n  background-color: #081B33 !important; /* match sidebar dark */\n  border-color: #081B33 !important;\n  color: #fafafaff !important;\n}\n\n.dark .fc .fc-col-header-cell {\n  border-bottom: 1px solid #081B33 !important;\n  border-right: 1px solid #081B33 !important;\n}\n\n.dark .fc-theme-standard .fc-scrollgrid {\n  border-color: #081B33 !important; /* remove white border in dark mode */\n}\n\n.dark .fc .fc-scrollgrid-section-header {\n  background: #1A1C23;\n}\n\n.dark .fc .fc-timegrid-axis,\n.dark .fc .fc-timegrid-slot-label {\n  background-color: #1A1C23 !important;\n  color: #A0AEC0 !important;\n  border-right: 2px solid #2E3138 !important;\n}\n\n.dark .fc .fc-timegrid-slot,\n.dark .fc .fc-timegrid-slot-lane {\n  border-right: 0px solid #2E3138 !important;\n  border-bottom: 0px solid #2E3138 !important;\n}\n\n.dark .fc .fc-timegrid-slot.fc-day-hover,\n.dark .fc .fc-timegrid-slot:hover {\n  background-color: rgba(49, 196, 171, 0.08) !important;\n}\n\n.dark .fc-day-today {\n  background-color: rgba(49, 196, 171, 0.1) !important;\n}\n\n/* Hide FullCalendar's internal loading indicator; we render our own overlay loader */\n.fc .fc-loading {\n  display: none !important;\n}\n\n/* ===== LAYOUT & POSITIONING ===== */\n\n/* Main calendar wrapper with offset for sticky header */\n.fc-has-offset {\n  padding-top: var(--header-offset, 64px);\n  min-height: calc(100vh - var(--header-offset, 64px));\n}\n\n/* Calendar grid background */\n.fc .fc-scrollgrid {\n  background: #ffffff;\n  top: var(--header-offset, 0px) !important;\n}\n\n/* View harness */\n.fc-view-harness {\n  margin-top: 0 !important;\n}\n\n.fc-resourceTimeGridDay-view .fc-view-harness {\n  min-width: fit-content;\n}\n\n.fc-resourceTimeGridDay-view .fc-scrollgrid {\n  min-width: 100%;\n}\n\n/* ===== SCROLLING ===== */\n.fc-scroller {\n  overflow-x: auto !important;\n  overflow-y: auto !important;\n}\n\n/* ===== HEADER STYLES ===== */\n\n/* Day-of-week header row (Mon, Tue, etc.) - Sticky positioning */\n.fc .fc-col-header {\n  position: sticky;\n  top: var(--header-offset, 64px) !important;\n  z-index: 35;\n  background-color: #223688 !important;\n}\n\n/* Individual header cells */\n.fc .fc-col-header-cell {\n  padding: 8px 4px !important;\n  background-color: #223688 !important;\n  color: #ffffff !important;\n  font-weight: bold;\n  border-bottom: 1px solid #ffffff !important;\n  border-right: 1px solid #ffffff !important;\n  font-size: 0.9rem;\n  position: sticky;\n  top: var(--header-offset, 64px);\n  z-index: 9999;\n}\n\n/* Section header */\n.fc-scrollgrid-section-header {\n  position: sticky;\n  top: var(--header-offset, 64px);\n  z-index: 5;\n  background: white;\n}\n\n/* ===== TIME GRID STYLES ===== */\n\n/* Time axis (left column with times) */\n.fc-timegrid-axis {\n  background-color: #ffffff !important;\n  color: #4e7bc3 !important;\n  font-weight: 500;\n  font-size: 0.875rem;\n  border-right: 2px solid #e5e7eb !important;\n  position: relative;\n  top: max(--header-offset, 96px) !important;\n}\n\n/* Time slot rows */\n.fc-timegrid-slot {\n  border-right: 0px solid #59606e !important;\n  border-bottom: 0px solid #c9cdd7 !important;\n  height: 20px !important;\n}\n\n/* Time slot lanes (cells) */\n.fc .fc-timegrid-slot-lane {\n  border-right: 0px solid #334976 !important;\n  border-bottom: 0px solid #e5e7eb !important;\n  min-height: 30px;\n}\n\n/* Remove border from last row */\n.fc .fc-timegrid-body tr:last-child .fc-timegrid-slot-lane {\n  border-bottom: none !important;\n}\n\n/* Time labels */\n.fc-timegrid-slot-label {\n  background-color: #ffffff !important;\n  color: #4e7bc3 !important;\n  font-weight: 500;\n  font-size: 0.875rem;\n  border-right: 2px solid #e5e7eb !important;\n}\n\n/* Time grid body */\n.fc-timegrid-body {\n  margin-top: 0;\n}\n\n/* Time grid event short */\n.fc-timegrid-event-short .event-content-wrapper {\n  padding: 0 !important;\n}\n\n.fc-resourceTimeGridDay-view .fc-datagrid-body {\n  margin-top: 0;\n}\n\n/* ===== HOVER STATES ===== */\n.fc .fc-timegrid-slot.fc-day-hover {\n  background-color: #6b7080 !important;\n}\n\n.fc .fc-timegrid-slot:hover {\n  background-color: inherit !important;\n}\n\n/* ===== TODAY HIGHLIGHT ===== */\n.fc-day-today {\n  background-color: #f0f0f240 !important;\n}\n\n/* ===== STANDARD EVENT STYLES & FULL-WIDTH OVERRIDES ===== */\n\n/* 1. Reset the master foreground layer to be fully edge-to-edge */\n.fc .fc-timegrid-col-events {\n  left: 0px !important;\n  right: 0px !important;\n  width: 100% !important; \n  margin: 0px !important;\n}\n\n/* 2. Reset the individual event harnesses inside so they stretch flush */\n.fc .fc-timegrid-col-events .fc-timegrid-event-harness {\n  margin-right: 0px !important; \n  margin-left: 0px !important;\n}\n\n/* 3. Base standard event styling */\n.fc-event {\n  background-color: #223688 !important;\n  color: white !important;\n  border-radius: 0px !important; /* Square corners */\n  padding: 0 !important;\n  font-weight: 600;\n  font-size: 0.875rem;\n  transition: filter 0.2s ease;\n  z-index: 100 !important; \n  \n  /* CRITICAL FIX: box-sizing prevents borders from expanding the event past its allotted width */\n  box-sizing: border-box !important;\n  border: 1px solid #1a2a6c !important; \n  box-shadow: none !important;\n}\n\n/* ===== EXCEPTION / BACKGROUND EVENT STYLES ===== */\n\n.fc .fc-timegrid-col-bg .fc-non-business {\n  z-index: 0;\n}\n\n/* 1. Force the FullCalendar harness to span the full width of the col-frame */\n.fc .fc-timegrid-col-bg .fc-timegrid-bg-harness {\n  left: 0px !important;\n  right: 0px !important;\n  width: 100% !important;\n  margin: 0px !important;\n}\n\n/* 2. Force the background event itself to perfectly fill the harness */\n.fc .fc-timegrid-col-bg .fc-bg-event,\n.fc .fc-bg-event,\n.fc-event.fc-bg-event {\n  left: 0px !important;\n  right: 0px !important;\n  width: 100% !important;\n  margin: 0px !important;\n  border-radius: 0px !important;\n  border: none !important;\n  outline: none !important;\n  z-index: 1 !important;\n  background-color: #fee2e2 !important; /* Light red background */\n  opacity: 0.85 !important;\n}\n\n/* 3. Ensure the column background area doesn't squeeze the harness */\n.fc .fc-timegrid-col-bg {\n  padding: 0px !important;\n  margin: 0px !important;\n}\n\n/* 4. Exception interactions */\n.fc .exception-event {\n  pointer-events: auto;\n}\n\n\n.fc-timegrid-col.fc-day-disabled {\n  pointer-events: none;\n}\n\n\n/* ===== CURRENT TIME INDICATOR ===== */\n.fc .fc-timegrid-now-indicator-arrow {\n  border-color: transparent transparent #9ca3de transparent !important;\n}\n\n.fc .fc-timegrid-now-indicator-line {\n  border-top: 2px solid #223688 !important;\n  z-index: 50;\n}\n\n\n/* ===== SPECIFIC APPOINTMENT STATUS COLORS ===== */\n\n/* In-Transit appointments - Gray */\n.fc-event.appt-in-transit,\n.appt-in-transit.fc-timegrid-event {\n  background-color: #d6d8dd !important;\n  border-color: #6b7280 !important; \n  color: #1f2937 !important; \n}\n\n.fc-event.appt-in-transit .fc-event-main,\n.fc-event.appt-in-transit .fc-event-title,\n.fc-event.appt-in-transit .fc-event-time,\n.appt-in-transit .fc-event-main,\n.appt-in-transit .fc-event-title,\n.appt-in-transit .fc-event-time {\n  color: #1f2937 !important; \n}\n\n/* Live Load appointments - Emerald Green */\n.fc-event.appt-live-load,\n.appt-live-load.fc-timegrid-event {\n  background-color: #a7f3d0 !important;\n  border-color: #059669 !important;\n  color: #022c22 !important;\n}\n.fc-event.appt-live-load .fc-event-main,\n.fc-event.appt-live-load .fc-event-title,\n.fc-event.appt-live-load .fc-event-time,\n.appt-live-load .fc-event-main,\n.appt-live-load .fc-event-title,\n.appt-live-load .fc-event-time {\n  color: #022c22 !important;\n}\n\n/* Drop Trailer appointments - Orange Yellow */\n.fc-event.appt-drop-trailer,\n.appt-drop-trailer.fc-timegrid-event {\n  background-color: #fed7aa !important;\n  border-color: #ea580c !important;\n  color: #431407 !important;\n}\n.fc-event.appt-drop-trailer .fc-event-main,\n.fc-event.appt-drop-trailer .fc-event-title,\n.fc-event.appt-drop-trailer .fc-event-time,\n.appt-drop-trailer .fc-event-main,\n.appt-drop-trailer .fc-event-title,\n.appt-drop-trailer .fc-event-time {\n  color: #431407 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
